import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isLoggedIn } from "../services/authService";
import { routes } from "../routes";
import { useAuth } from "../contexts/authContext";

interface ProtectedRouteProps {
  children: React.ReactElement;
  redirectPath?: string;
  capabilities: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  capabilities,
  redirectPath,
}) => {
  const location = useLocation();
  const { loggedUser } = useAuth();

  if (!isLoggedIn()) {
    const redirectPath = `${location.pathname}${location.search}${location.hash}`;

    // Redirect to login only for protected routes, preserving the requested page.
    return (
      <Navigate
        to={`${routes.LOGIN}?redirect=${encodeURIComponent(redirectPath)}`}
        state={{ from: location }}
        replace
      />
    );
  }
  // controllare quando l'utente non ha authorities
  const isAdmin = loggedUser?.authorities?.some((a) => a.name === "ROLE_ADMIN");

  const hasRequiredCapability = capabilities?.some((capability) =>
    loggedUser?.authorities?.some((authority) => authority.name === capability)
  );

  // magari possiamo mostrare un messaggio di errore
  if (!isAdmin && !hasRequiredCapability)
    return (
      <Navigate to={redirectPath ? redirectPath : `${routes.HOME}`} replace />
    );

  return children;
};

export default ProtectedRoute;
